import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { ResultadoBinario } from '@/types/enums';

import type { EctoparasitosFormValues } from '../schemas';

export function EctoparasitosResultadoForm(): JSX.Element {
  const { control } = useFormContext<EctoparasitosFormValues>();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
        gap: 2,
      }}
    >
      <Controller
        control={control}
        name="muestra.categoria"
        render={({ field, fieldState }) => (
          <TextField
            label="Categoría *"
            size="small"
            fullWidth
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="muestra.muestra"
        render={({ field, fieldState }) => (
          <TextField
            label="Muestra *"
            size="small"
            fullWidth
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="muestra.valor"
        render={({ field, fieldState }) => (
          <FormControl size="small" fullWidth error={!!fieldState.error}>
            <InputLabel>Resultado *</InputLabel>
            <Select label="Resultado *" value={field.value} onChange={field.onChange} onBlur={field.onBlur}>
              <MenuItem value={ResultadoBinario.NEGATIVO}>Negativo</MenuItem>
              <MenuItem value={ResultadoBinario.POSITIVO}>Positivo</MenuItem>
            </Select>
            {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
          </FormControl>
        )}
      />

      <Controller
        control={control}
        name="muestra.descripcion_resultado"
        render={({ field }) => (
          <TextField
            label="Descripción resultado"
            size="small"
            fullWidth
            value={field.value ?? ''}
            onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
            onBlur={field.onBlur}
          />
        )}
      />

      <Box sx={{ gridColumn: { sm: '1 / -1' } }}>
        <Controller
          control={control}
          name="muestra.observacion"
          render={({ field }) => (
            <TextField
              label="Observación"
              size="small"
              fullWidth
              multiline
              rows={3}
              value={field.value ?? ''}
              onChange={(e) => field.onChange(e.target.value !== '' ? e.target.value : null)}
              onBlur={field.onBlur}
            />
          )}
        />
      </Box>
    </Box>
  );
}
